import React from "react";
import { CollinsUserContextType } from "../../context/CollinsUserContext";
import { INavigationMenuItem } from "../../types/NavigationMenu";
import { isExternalUrl } from "../nativeUtils/openExternalLink";
import { openCollinsAdminLink, WorkspaceContext } from "./openCollinsAdminLink";
import {
  Lock,
  CheckCircle,
  Calendar,
  HelpCircle,
  Star,
  User,
  Clipboard,
  Users,
  LayoutDashboard,
  GripVertical,
  FlaskConical,
  IdCard,
  TrendingUp,
  Map,
  Pin,
  Settings
} from "lucide-react";
import dayjs from "dayjs";

export const getMenuItemNames = (
  item: INavigationMenuItem,
  userContext?: CollinsUserContextType
) => {
  const itemName = item.text
    .replace(/\{\{(.*?)\}\}/, "$1") // Extract text between {{ }}
    .replace(/Text/g, "") // Remove "Text" from the name
    .replace(/\s+/g, "") // Remove extra spaces
    .trim(); // Trim any extra spaces

  if (item.text.includes("{{ currentUser.first_name }}")) {
    const userName =
      `${userContext?.user?.first_name} ${userContext?.user?.last_name}`.trim();
    return userName;
  } else return itemName;
};

export const getOptionHandler = (
  item: INavigationMenuItem,
  navigateTo?: (path: string) => void,
  appBaseUrl?: string,
  workspace?: WorkspaceContext
) => {
  if (item.function) {
    return () => item.function?.();
  }
  if (item.link) {
    return () => {
      const link = (item.link ?? "").trim();
      if (isExternalUrl(link)) {
        openCollinsAdminLink(link, appBaseUrl ?? "", workspace);
      } else {
        navigateTo?.(link);
      }
    };
  } else {
    return () => {
      navigateTo?.(`/${getMenuItemNames(item)}`);
    };
  }
};

export const getIcons = (iconName: string | undefined): React.ReactElement => {
  switch (iconName?.toLowerCase()) {
    case "dashboard":
      return <LayoutDashboard className="size-5" />;
    case "contacts":
      return <Users className="size-5" />;
    case "calendar":
      return <Calendar className="size-5" />;
    case "circlestar":
      return <Star className="size-5" />;
    case "map2":
      return <Map className="size-5" />;
    case "clipboard":
      return <Clipboard className="size-5" />;
    case "linechartsolid2":
      return <TrendingUp className="size-5" />;
    case "id":
      return <IdCard className="size-5" />;
    case "settings2":
      return <Settings className="size-5" />;
    case "booktick":
      return <CheckCircle className="size-5" />;
    case "circlequestionmark":
      return <HelpCircle className="size-5" />;
    case "flask":
      return <FlaskConical className="size-5" />;
    case "pushpin":
      return <Pin className="size-5" />;
    case "drag2":
      return <GripVertical className="size-5" />;
    case "circleuser":
      return <User className="size-5" />;
    default:
      return <Lock className="size-5" />;
  }
};

export const getVenueLink = (
  item: INavigationMenuItem,
  venueId: string | undefined
) => {
  const newItem = { ...item };
  newItem.link = newItem.link
    ?.replace("{{venueId}}", venueId ?? "")
    .replace("{{date}}", dayjs().format("YYYY-MM-DD"));
  return newItem.link ?? "/";
};
